import { render } from "./editpermission.vue?vue&type=template&id=27280f9f"
import script from "./editpermission.vue?vue&type=script&lang=js"
export * from "./editpermission.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__